<template>
  <div id="signup">
    <div class="con_all">
      <div class="con_box2">
        <div class="ca_title">
          <div class="ca_l">
            <span class="con_title con_title_line">{{className}} {{classTypeName(admission)}} {{admission.classHour}} {{showPage.application}}</span>
          </div>
          <div class="fix"></div>
        </div>
        <div class="team2_mbox">
          <div class="siup_box">
            <div class="siup_l"><i class="require"></i>{{showPage.name}}</div>
            <div class="siup_l">
              <input name="" type="text" class="sign_inp3" v-model="recordToEdit.name">
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l">{{showPage.sex}}
              <div class="siup_r">
                <input name="" type="radio" value="1" v-model="recordToEdit.sex"> {{showPage.male}}
                <span class="ml20 mr20"><input name="" type="radio" value="0" v-model="recordToEdit.sex"> {{showPage.female}}</span>
                <input name="" type="radio" value="2" v-model="recordToEdit.sex"> {{showPage.unkown}}
              </div>
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l"><i class="require"></i>{{showPage.ID}}</div>
            <div class="siup_l">
              <input name="" type="text" class="sign_inp3" v-model="recordToEdit.idNo">
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l">{{showPage.birthday}}</div>
            <div class="siup_l">
              <DatePicker type="date" placeholder="出生年月日" :value="recordToEdit.birthday" @on-change="dateChange" style="width:110px"></DatePicker>
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l"><i class="require"></i>{{showPage.parent}}</div>
            <div class="siup_l">
              <input name="" type="text" class="sign_inp3" v-model="recordToEdit.parentsName">
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l"><i class="require"></i>{{showPage.serviceunits}}</div>
            <div class="siup_l">
              <input name="" type="text" class="sign_inp3" v-model="recordToEdit.serviceUnit">
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l"><i class="require"></i>{{showPage.tel}}</div>
            <div class="siup_l">
              <input name="" type="text" class="sign_inp3" v-model="recordToEdit.tel">
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l"><i class="require"></i>{{showPage.mobile}}</div>
            <div class="siup_l">
              <input name="" type="text" class="sign_inp3" v-model="recordToEdit.mobile">
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l"><i class="require"></i>Email</div>
            <div class="siup_l">
              <input name="" type="text" class="sign_inp3" v-model="recordToEdit.email">
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l"><i class="require"></i>{{showPage.address}}</div>
            <div class="siup_l">
              <input name="" type="text" class="sign_inp3" v-model="recordToEdit.address">
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l">{{showPage.classtype}}
              <div class="siup_r">
                <input type="radio" name="" v-model="recordToEdit.memberType" value="1">{{showPage.adult}}
                <span class="ml20 mr20">
                                      <input type="radio" name="" v-model="recordToEdit.memberType" value="2">{{showPage.child}}
                          </span>
              </div>
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l">{{showPage.charges}}
              <div class="siup_r">
                <input name="" type="radio" value="1" v-model="recordToEdit.chargesType"> {{showPage.onCampus}}  <spen v-show="admission.charges1 && admission.charges1 > 0 ">${{admission.charges1}}</spen>
                <span class="ml20 mr20">
                  <input name="" type="radio" value="2" v-model="recordToEdit.chargesType"> {{showPage.offCampus}} <spen v-show="admission.charges2 && admission.charges2 > 0 ">${{admission.charges2}}</spen>
                </span>
              </div>
            </div>
          </div>
          <div class="w_box">{{showPage.applynote}}</div>
          <div class="siup_box">
            <div class="siup_l">{{showPage.classWeek}}
              <div class="siup_r">
                <input name="" type="checkbox" value="1" v-model="recordToEdit.classWeek"> {{showPage.mon}}
                <span class="ml20"><input name="" type="checkbox" value="2" v-model="recordToEdit.classWeek"> {{showPage.tue}}</span>
                <span class="ml20"><input name="" type="checkbox" value="3" v-model="recordToEdit.classWeek"> {{showPage.wed}}</span>
                <span class="ml20"><input name="" type="checkbox" value="4" v-model="recordToEdit.classWeek"> {{showPage.thu}}</span>
                <span class="ml20"><input name="" type="checkbox" value="5" v-model="recordToEdit.classWeek"> {{showPage.fri}}</span>
                <span class="ml20"><input name="" type="checkbox" value="6" v-model="recordToEdit.classWeek"> {{showPage.sat}}</span>
                <span class="ml20"><input name="" type="checkbox" value="7" v-model="recordToEdit.classWeek"> {{showPage.sun}}</span>
              </div>
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l">{{showPage.classcount}}</div>
            <div class="siup_l">
              <InputNumber style="width: 50px;margin: 0 4px;" :min="0" v-model="recordToEdit.classCount"></InputNumber> {{showPage.lesson}}
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l">{{showPage.classtime}}</div>
            <div class="siup_l">
              <div class="">
                <input name="" type="checkbox" value="1" v-model="recordToEdit.classTime"> 17：00～18：00
                <span class="ml20"><input name="" type="checkbox" value="2" v-model="recordToEdit.classTime"> 18：00～19：00</span>
              </div>
              <div class="mt10">
                <input name="" type="checkbox" value="3" v-model="recordToEdit.classTime"> 19：00～20：00
                <span class="ml20"><input name="" type="checkbox" value="4" v-model="recordToEdit.classTime"> 20：00～21：00</span>
              </div>
              <div class="mt10">
                <input name="" type="checkbox" value="5" v-model="recordToEdit.classTime"> {{showPage.other}}
                <input name="" type="text" class="sign_inp4" v-model="recordToEdit.classTimeOther">
              </div>
            </div>
          </div>
          <div class="siup_box">
            <div class="siup_l">{{showPage.coachrequirements}}
              <div class="siup_r">
                <input name="" type="radio" value="1" v-model="recordToEdit.coach"> {{showPage.coachMale}}
                <span class="ml20 mr20"><input name="" type="radio" value="0" v-model="recordToEdit.coach"> {{showPage.coachFeMale}}</span>
                <input name="" type="radio" value="2" v-model="recordToEdit.coach"> {{showPage.coachSpecified}}
                <input name="" type="text" class="sign_inp4" v-model="recordToEdit.coachOther">
              </div>
            </div>
          </div>
          <!--<div class="w_box">各項報名注意事項</div>-->
          <div class="w_box">{{admission.memo}}</div>
          <input name="" type="checkbox" value="" v-model="agree"> {{showPage.agree}}
          <div class="fix"></div>
        </div>
        <div class="pagination-row text-center">
          <button type="submit" class="gue_btn" @click="saveData">{{showPage.signup}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'signup',
  data() {
    return {
      showPage: ShowPage(sessionStorage.getItem('locale')),
      className: this.$route.params.classname,
      admissionsId: this.$route.params.admissionsid,
      classNow: {},
      admission: {},
      recordToEdit: {
        name: '',
        sex: 2,
        idNo: '',
        birthday: '',
        parentsName: '',
        serviceUnit: '',
        tel: '',
        mobile: '',
        email: '',
        address: '',
        memberType: 1,
        chargesType: 1,
        classWeek: [],
        classCount: 0,
        classTime: [],
        classTimeOther: '',
        coach: 0,
        coachOther: '',
      },
      agree: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initClass();
      this.initAdmission();
    },
    initClass() {
      this.getClassData();
    },
    initAdmission() {
      this.getAdmissionData();
    },
    getClassData() {
      axios.get(API.class + `?id=${this.classId}`)
        .then(response => {
          this.classNow = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getAdmissionData() {
      axios.get(API.classadmissions + `?id=${this.admissionsId}`)
        .then(response => {
          this.admission = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    saveData() {
      try {
        this.checkField();
      } catch (error) {
        alert(error.message);
        return;
      }

      let form = new FormData();

      form.append('admissionsId', this.admissionsId);
      form.append('name', this.recordToEdit.name || '');
      form.append('sex', this.recordToEdit.sex || '');
      form.append('idNo', this.recordToEdit.idNo || '');
      form.append('birthday', this.recordToEdit.birthday || '');
      form.append('parentsName', this.recordToEdit.parentsName || '');
      form.append('serviceUnit', this.recordToEdit.serviceUnit || '');
      form.append('tel', this.recordToEdit.tel || '');
      form.append('mobile', this.recordToEdit.mobile || '');
      form.append('email', this.recordToEdit.email || '');
      form.append('address', this.recordToEdit.address || '');
      form.append('memberType', this.recordToEdit.memberType.toString());
      form.append('chargesType', this.recordToEdit.chargesType || 0);
      form.append('classWeek', JSON.stringify(this.recordToEdit.classWeek) || '');
      form.append('classCount', this.recordToEdit.classCount.toString());
      form.append('classTime', JSON.stringify(this.recordToEdit.classTime) || '');
      form.append('classTimeOther', this.recordToEdit.classTimeOther || '');
      form.append('coach', this.recordToEdit.coach.toString());
      form.append('coachOther', this.recordToEdit.coachOther || '');

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.application, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
          this.$router.push({ name: 'class_item' });
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'application');
        });
    },
    checkField() {
      this.checkAgree();
      this.checkEmpty();
      this.checkClassCount();
      this.checkIdNo();
      this.checkTel();
      this.checkMobile();
      this.checkEmail();
    },
    checkEmpty() {
      if (!this.recordToEdit.name)
        throw new Error('姓名必填')
      if (!this.recordToEdit.classCount)
        throw new Error('課堂數必填')
      if (!this.recordToEdit.idNo)
        throw new Error('身分證字號必填')
      if (!this.recordToEdit.parentsName)
        throw new Error('家長必填')
      if (!this.recordToEdit.serviceUnit)
        throw new Error('服務單位必填')
      if (!this.recordToEdit.tel)
        throw new Error('聯絡電話必填')
      if (!this.recordToEdit.mobile)
        throw new Error('手機必填')
      if (!this.recordToEdit.email)
        throw new Error('Email必填')
      if (!this.recordToEdit.address)
        throw new Error('聯絡地址必填')
    },
    checkClassCount() {
      if (isNaN(parseInt(this.recordToEdit.classCount)))
        throw new Error('課堂數需為數字')
    },
    checkIdNo() {
      let regExp = /^[A-Z][0-9]{9}$/;
      if (!this.recordToEdit.idNo.match(regExp)) {
        throw new Error('身分證字號無效');
      }
    },
    checkTel() {
      let regExp = /^[0-9\-()]*$/;
      if (this.recordToEdit.tel && !this.recordToEdit.tel.match(regExp)) {
        throw new Error('電話欄位無效');
      }
    },
    checkMobile() {
      let regExp = /^09[0-9]{8}$/;
      if (this.recordToEdit.mobile && !this.recordToEdit.mobile.match(regExp)) {
        throw new Error('手機欄位無效');
      }
    },
    checkEmail() {
      let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.recordToEdit.email) {
        throw new Error('請填寫電子信箱');
      }
      if (this.recordToEdit.email && !this.recordToEdit.email.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    },
    checkAgree() {
      if (!this.agree)
        throw new Error('請先詳閱上課須知及各注意事項，並同意遵行');
    },
    checkClassCount() {
      if (this.recordToEdit.classCount && isNaN(parseInt(this.recordToEdit.classCount)))
        throw new Error('課堂數需為數字')
    },
    dateChange(date) {
      this.recordToEdit.birthday = date;
    },
    classTypeName(admission) {
      if (sessionStorage.locale === 'CH') {
        let level = ['', '初階', '進階', '矯正'],
          maxPersonal = ['零', '一', '二', '三', '四', '五'];
        if (admission.type === 1) {
          return admission.maxPersonal + level[admission.classLevel] + '班';
        } else if (admission.type === 2) {
          return '團體' + level[admission.classLevel] + '班';
        }
      } else {
        let level = ['', 'Beginner', 'Advanced', 'Correction'],
          maxPersonal = ['zero', 'one', 'two', 'three', 'four', 'five'];
        if (admission.type === 1) {
          return admission.maxPersonal + ' ' + level[admission.classLevel] + ' class';
        } else if (admission.type === 2) {
          return 'Group ' + level[admission.classLevel] + ' Class';
        }
      }
    },
  },
}

</script>
<style lang="scss">
#signup {
  .cla_box {
    width: 100%;
    background: red;
    padding: 15px 20px;
    margin-top: 20px;
    border-radius: 3px;
    background: -webkit-linear-gradient(0deg, #E7E7E7, #fff);
    background: linear-gradient(0deg, #E7E7E7, #fff);
    border: 1px solid #E2E2E2;
    border-bottom: 1px solid #A2A2A2;
  }
  .require {
    &:before {
      content: "*";
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 12px;
      color: #ed3f14;
    }
  }
}

</style>



// WEBPACK FOOTER //
// SignUp.vue?2df6a8f0